import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../media/TCOpfingen_Logo.png";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { API_BASE_URL } from '../App.js';

function ResetPassword() {
    const location = useLocation();
    const [newPassword, setNewPassword] = useState("");
    const [newPassword1, setNewPassword1] = useState("");
    const [isPasswordReset, setIsPasswordReset] = useState(true);
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const userId = queryParams.get('playerId');
    const navigate = useNavigate();

    useEffect(() => {

        if (!token || !userId ) {
            toast.error("Ungültiger Link oder Token!");
            navigate("/login");
            return;
          }
        // Überprüfen, ob es sich um eine Passwort-Zurücksetzung oder eine erstmalige Passwort-Setzung handelt
        setIsPasswordReset(location.pathname !== '/set-password');
    }, [location.pathname, token, userId, navigate]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (newPassword !== newPassword1) {
            toast.error("Die Passwörter stimmen nicht überein");
            return;
        }
        
        const formData = {
            token: token,
            playerId: userId,
            newPassword: newPassword
        };
        try {
            const endpoint = isPasswordReset ? "/api/password-reset-confirm" : "/api/set-password";
            await axios.post(`${API_BASE_URL}${endpoint}`, formData);
            toast.success(isPasswordReset ? "Passwort erfolgreich zurückgesetzt" : "Passwort erfolgreich gesetzt");
            navigate("/login");
        } catch (error) {
            toast.error(error.response?.data?.message || "Ein Fehler ist aufgetreten");
        }
    };

    return (
        <div className='login px-3 py-3 rounded shadow-lg'>
            <div>
                <div className='d-flex justify-content-center'>
                    <img className="login-logo my-4" src={logo} alt="logo" />
                </div>
                <div className='text-center fw-semibold'>
                    {isPasswordReset ? "Passwort zurücksetzen" : "Neues Passwort setzen"}
                </div>
                <div>
                    <Form onSubmit={handleSubmit} className='text-center'>
                        <div className='d-flex justify-content-center align-items-center textfield'>
                            <div>
                                <Form.Group className="mb-3" controlId="formGroupNewPassword">
                                    <TextField
                                        id="newPassword"
                                        label="Neues Passwort"
                                        size="small"
                                        variant="outlined"
                                        type="password"
                                        className='bg-white-25 rounded'
                                        sx={{ width: '300px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#e53935' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: '#e53935' } } }}
                                        onChange={e => setNewPassword(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group controlId="formGroupConfirmPassword">
                                    <TextField
                                        id="confirmPassword"
                                        label="Passwort bestätigen"
                                        variant="outlined"
                                        size="small"
                                        type="password"
                                        sx={{ width: '300px', '& .MuiOutlinedInput-root': { '&.Mui-focused fieldset': { borderColor: '#e53935' } }, '& .MuiInputLabel-root': { '&.Mui-focused': { color: '#e53935' } } }}
                                        className='bg-white-25 rounded'
                                        onChange={e => setNewPassword1(e.target.value)}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                        <div className='text-center'>
                            <Button variant="contained" color="error" type="submit">
                                {isPasswordReset ? "Zurücksetzen" : "Erstellen"}
                            </Button>
                        </div>
                    </Form>
                    <div className='text-center'>
                        <div className='mx-2 mt-3 arrow' onClick={() => navigate("/login")}>Zum Login</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResetPassword;
